'use strict';

var getFetchResponseCookies = require('./getFetchResponseCookies.js');
var fetch = require('./fetch.js');

/* eslint-disable no-console */
async function fetchJSON(url, options = {}) {
  options = {
    credentials: 'include',
    // should this be defaulted?
    method: 'GET',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  };
  if (['POST', 'PATCH', 'PUT'].includes(options.method)) {
    // default options.body to empty object
    // if it does not exist
    if (!options.body) {
      options.body = {};
    }
    const {
      query = {},
      search = {},
      data = {}
    } = options;

    // merge all request data options to body for posts
    options.body = JSON.stringify({
      ...data,
      ...query,
      ...search,
      ...options.body
    });
  }
  const response = await fetch.bonnetFetch(url, options);
  try {
    const json = await response.json();
    if (typeof options.responseInterceptor === 'function') {
      const cookies = getFetchResponseCookies.getFetchResponseCookies(response);
      options.responseInterceptor(response, {
        json,
        cookies
      });
    }
    return json;
  } catch (error) {
    let errorLog = `[BONNET FETCH JSON ERROR]\nURL: ${url}\n`;
    if (response && response.status) {
      errorLog += `STATUS: ${response.status}\n`;
    }

    // eslint-disable-next-line no-console
    console.error(errorLog, error);
    return {};
  }
}

exports.fetchJSON = fetchJSON;
